import axios from 'axios';
import { API_URL } from '../config';

const API_ENDPOINT = `${API_URL}/config`;

// Get all config settings
export const getAllConfigs = async () => {
  try {
    const response = await axios.get(API_ENDPOINT);
    return response.data;
  } catch (error) {
    
    throw error;
  }
};

// Get a specific config by key
export const getConfigByKey = async (key) => {
  try {
    const response = await axios.get(`${API_ENDPOINT}/${key}`);
    return response.data;
  } catch (error) {
    
    throw error;
  }
};

// Update a specific config
export const updateConfig = async (key, value, token) => {
  try {
    const response = await axios.post(
      `${API_ENDPOINT}/${key}`,
      { value },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    
    throw error;
  }
};

// Update multiple configs at once
export const updateMultipleConfigs = async (configs, token) => {
  try {
    const response = await axios.put(
      API_ENDPOINT,
      { configs },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    
    throw error;
  }
};

// Delete a config
export const deleteConfig = async (key, token) => {
  try {
    const response = await axios.delete(
      `${API_ENDPOINT}/${key}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    
    throw error;
  }
};

// Get Omniva parcel machine locations
export const getOmnivaLocations = async () => {
  try {
    const response = await axios.get(`${API_ENDPOINT}/omniva/locations`);
    return response.data;
  } catch (error) {
    // Log with warning level instead of error to reduce console noise
    
    // Return a structured error response instead of throwing
    return {
      success: false,
      data: [],
      message: error.response?.data?.message || error.message
    };
  }
};

// Update Omniva parcel machine locations
export const updateOmnivaLocations = async (token) => {
  try {
    const response = await axios.post(
      `${API_ENDPOINT}/omniva/update`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    
    throw error;
  }
};

// Generate Omniva tracking number
export const generateOmnivaTracking = async (data, token) => {
  try {
    const response = await axios.post(
      `${API_ENDPOINT}/omniva/generate`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    
    throw error;
  }
};

// Generate Omniva label from existing barcode
export const generateOmnivaLabel = async (barcode, token) => {
  try {
    const response = await axios.post(
      `${API_ENDPOINT}/omniva/label`,
      { barcode },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    
    throw error;
  }
};

// Get all enabled countries from the database
export const getEnabledCountries = async () => {
  try {
    const response = await axios.get(`${API_URL}/config/countries`);
    return response.data;
  } catch (error) {
    // Log with warning level instead of error to reduce console noise
    
    // Return a structured error response instead of throwing
    return { 
      success: false, 
      data: [], 
      message: error.response?.data?.message || error.message 
    };
  }
};

// Get all countries from the database (fallback)
export const getCountries = async () => {
  try {
    const response = await axios.get(`${API_URL}/config/countries`);
    return response.data;
  } catch (error) {
    // Log with warning level instead of error to reduce console noise
    
    // Return a structured error response instead of throwing
    return { 
      success: false, 
      data: [], 
      message: error.response?.data?.message || error.message 
    };
  }
};